export default __webpack_public_path__ + "static/media/Spinner.218a6888.gif";